import { Routes } from '@angular/router';
import { AboutUsComponent } from "./about-us/about-us.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { HomeComponent } from "./home/home.component";
import { ClientComponent } from "./client/client.component";
import { FactoryServiceComponent } from "./factory-service/factory-service.component";
import { ProductComponent } from "./product/product.component";
import { PrototypeComponent } from "./prototype/prototype.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";


export const routes: Routes = [

    {
        path: "about-us",
        component: AboutUsComponent
    },

    {
        path: "home",
        component: HomeComponent
    },


    {
        path: "contact-us",
        component: ContactUsComponent
    },

    {
        path: "client",
        component: ClientComponent
    },

    {
        path: "service",
        component: FactoryServiceComponent
    },

    {
        path: "product",
        component: ProductComponent
    },

    {
        path: "prototype",
        component: PrototypeComponent
    },

    {
        path: "",
        redirectTo: "/home",
        pathMatch: "full",
    },
    {
        path: "**",
        component: PageNotFoundComponent,
    },
    


];
